import { z } from 'zod';
import { defineEndpoint } from '../define';

// API build identity, same scheme as the web bundle's vite-baked constants:
// short hash / full hash / YYYYMMDD commit date ("dev" when unknown).
export const ApiVersionSchema = z.object({
  commitHash: z.string(),
  commitHashFull: z.string(),
  commitDate: z.string(),
});
export type ApiVersion = z.infer<typeof ApiVersionSchema>;

export const GetApiVersionResponseSchema = z.object({ data: ApiVersionSchema });

export const getApiVersion = defineEndpoint({
  method: 'GET',
  path: '/v1/version',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: GetApiVersionResponseSchema,
});
